import React, { useState, useEffect } from "react";
import api from "../../api";

const AnimatedProgressBar = ({ usercourseid }) => {
  const [displayedProgress, setDisplayedProgress] = useState(0); // State for displaying progress
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null); // State for error handling

  useEffect(() => {
    // Update the displayed progress smoothly over time based on data
    if (data) {
      const overallProgress = (data.points / data.counter) * 100;
      setDisplayedProgress(overallProgress);
    }
  }, [data]); // This hook runs whenever `data` changes.

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null); // Reset error state before fetching
        const res = await api.get(`/api/reports/getprogress/${usercourseid}`);
        setData(res.data); // Assume data contains { counter, points }
      } catch (err) {
        console.error("Error fetching progress data:", err);
        setError("Error fetching progress data. Please try again."); // Set error message
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [usercourseid]);

  // Debugging the fetched data
  console.log(data);

  return (
    <div className="w-full max-w-sm mx-auto p-4 bg-white rounded-lg shadow-md">
      <div className="flex justify-between mb-2">
        <span className="text-base font-semibold text-black">
          Task Progress
        </span>
        <span className="text-sm font-medium text-black">
          {loading ? (
            <span className="text-blue-500">Loading...</span> // Show loading message
          ) : error ? (
            <span className="text-red-500">{error}</span> // Show error message
          ) : (
            `${Math.round(displayedProgress)}%`
          )}
        </span>
      </div>

      {/* Unified Overall Progress Bar */}
      <div className="w-full bg-gray-200 rounded-full h-3 overflow-hidden">
        <div
          className="bg-indigo-600 h-3 rounded-full transition-all duration-1000 ease-in-out"
          style={{ width: `${Math.round(displayedProgress)}%` }}
        ></div>
      </div>

      {/* Display Points and Counter */}
      {data && !loading && !error && (
        <div className="mt-4 flex justify-between">
          <span className="text-gray-700">Points: {data.points}</span>
          <span className="text-gray-700">Counter: {data.counter}</span>
        </div>
      )}
    </div>
  );
};

export default AnimatedProgressBar;
